import { AdditionalInfoState } from '@/models/www/store/AdditionalInfoState';
import { stateStorage } from '@/services/storage.service';
import { defineStore } from 'pinia';

export const useAdditionalInfoStore = defineStore('additionalInfo', {
    state: () => {
        return {
            accomodationName: '',
            accomodationArea: '',
            numberOfVisits: ''
        } as AdditionalInfoState
    },
    getters: {
        getState: (state) => {
            return state;
        }
    },
    actions: {
        setState(state: AdditionalInfoState) {
            this.$state = state;
        }
    },
    persist: {
        enabled: true,
        strategies: [
            { storage: stateStorage },
        ],
    },
})